export default __webpack_public_path__ + "static/media/img.8546b743.png";